import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Button from '../../components/buttons/buttons.component'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'

const StyledPolicy = styled.div`
	p {
		text-align: justify;
	}

	h2 {
		font-size: 3rem;
		margin-top: 3rem;
		margin-bottom: 1rem;
	}

	.subtitle {
		margin-top: 2rem;
		margin-bottom: 0.5rem;
	}

	ul {
		list-style: disc;
		padding-left: 2.4rem;
		margin-bottom: 1.5rem;

		li {
			text-align: justify;
			margin-bottom: 0.8rem;
		}
	}

	.checklist {
		list-style: none;
		padding-left: 0;

		li {
			margin-bottom: 1rem;
		}

		li::before {
			content: '✔';
			color: var(--title-color);
			font-weight: 600;
			margin-right: 0.8rem;
		}
	}

	.summary {
		list-style: decimal;
		padding-left: 2.4rem;

		li {
			margin-bottom: 0.4rem;
		}
	}
`

class PolicyPage extends Component {
	render() {
		const { history } = this.props

		return (
			<Container medium style={{ paddingBottom: '5rem' }}>
				<StyledPolicy>
					<Title>
						<span className="bold">Aviso de Privacidade</span>
					</Title>

					<p className="center italic blue">Como cuidamos dos seus dados pessoais</p>

					<h2 className="blue bold">O que você precisa saber</h2>
					<ul className="checklist">
						<li>Coletamos seus dados para emitir passagens, processar pagamentos e manter você informado.</li>
						<li>Não vendemos seus dados pessoais a ninguém.</li>
						<li>Você pode pedir acesso, correção ou exclusão dos seus dados a qualquer momento.</li>
						<li>Se você autorizou o recebimento de promoções, pode cancelar isso quando quiser.</li>
						<li>
							Em caso de dúvida, fale com a nossa Encarregada de Proteção de Dados:{' '}
							<a href="mailto:encarregadodedados@jmt.com.br">encarregadodedados@jmt.com.br</a>
						</li>
					</ul>

					<h2 className="blue bold">Sumário</h2>
					<ol className="summary">
						<li>Quem somos</li>
						<li>Quais dados coletamos?</li>
						<li>Por que usamos seus dados?</li>
						<li>Com quem compartilhamos seus dados?</li>
						<li>Por quanto tempo guardamos seus dados?</li>
						<li>Como protegemos seus dados?</li>
						<li>Usamos cookies?</li>
						<li>Quais são os seus direitos?</li>
						<li>O que acontece em caso de incidente de segurança?</li>
						<li>Fale com a nossa Encarregada de Proteção de Dados</li>
					</ol>

					<h2 className="blue bold">1. Quem somos</h2>
					<p>
						Somos uma empresa que atua no setor de transporte terrestre de passageiros. Sempre que você
						utiliza nossos serviços, realiza uma compra, envia um currículo ou entra em contato conosco, nos
						confia alguns dados pessoais. Este Aviso explica o que fazemos com esses dados, de forma clara e
						direta, em conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD — Lei nº
						13.709/2018).
					</p>

					<h2 className="blue bold">2. Quais dados coletamos?</h2>
					<p>Dependendo do serviço que você utiliza, podemos coletar:</p>
					<ul>
						<li>
							Nome completo, CPF, RG, data de nascimento — para emitir sua passagem ou Conhecimento de
							Transporte Eletrônico (CT-e);
						</li>
						<li>Endereço, telefone e e-mail — para entrar em contato e enviar confirmações;</li>
						<li>
							Dados de pagamento — processados por empresas especializadas e certificadas. Não armazenamos
							números de cartão de crédito;
						</li>
						<li>Endereço IP e histórico de compras — para identificar e prevenir fraudes;</li>
						<li>
							Localização aproximada — quando você acessa nosso aplicativo ou site, para personalizar
							ofertas próximas a você (somente com sua autorização prévia);
						</li>
						<li>
							Nome, telefone, e-mail, RG ou CNH, endereço e histórico profissional — quando você se
							candidata a uma vaga de emprego via WhatsApp ou outros canais.
						</li>
					</ul>

					<h2 className="blue bold">3. Por que usamos seus dados?</h2>
					<p>
						Utilizamos seus dados exclusivamente para finalidades específicas e legítimas, sempre amparadas
						em uma das hipóteses legais previstas na LGPD. A seguir, descrevemos as principais situações:
					</p>

					<p className="subtitle bold blue">Emissão de passagem ou CT-e</p>
					<p>
						<span className="bold">Finalidade:</span> emitir o documento de viagem ou Conhecimento de
						Transporte Eletrônico. <span className="bold">Titulares afetados:</span> clientes e passageiros.{' '}
						<span className="bold">Hipótese legal:</span> execução de contrato (art. 7º, V da LGPD).{' '}
						<span className="bold">Dados utilizados:</span> nome, CPF, RG e dados de pagamento.
					</p>

					<p className="subtitle bold blue">Confirmação de compra</p>
					<p>
						<span className="bold">Finalidade:</span> enviar comprovante e informações da viagem por e-mail.{' '}
						<span className="bold">Titulares afetados:</span> clientes e passageiros.{' '}
						<span className="bold">Hipótese legal:</span> execução de contrato (art. 7º, V da LGPD).{' '}
						<span className="bold">Dados utilizados:</span> e-mail e telefone.
					</p>

					<p className="subtitle bold blue">Prevenção a fraudes</p>
					<p>
						<span className="bold">Finalidade:</span> identificar transações suspeitas por meio de análise
						automatizada. Nenhuma compra é bloqueada sem análise prévia.{' '}
						<span className="bold">Titulares afetados:</span> usuários do site e aplicativo.{' '}
						<span className="bold">Hipótese legal:</span> legítimo interesse (art. 7º, IX da LGPD).{' '}
						<span className="bold">Dados utilizados:</span> endereço IP e histórico de compras.
					</p>

					<p className="subtitle bold blue">Envio de promoções</p>
					<p>
						<span className="bold">Finalidade:</span> enviar ofertas e comunicações relevantes ao seu perfil.
						Você pode revogar a autorização a qualquer momento.{' '}
						<span className="bold">Titulares afetados:</span> clientes que consentiram.{' '}
						<span className="bold">Hipótese legal:</span> consentimento (art. 7º, I da LGPD).{' '}
						<span className="bold">Dados utilizados:</span> e-mail e localização aproximada.
					</p>

					<p className="subtitle bold blue">Processo seletivo — recrutamento via WhatsApp</p>
					<p>
						<span className="bold">Finalidade:</span> cadastrar, triar, avaliar e contatar candidatos durante
						processos seletivos. O candidato é informado sobre o Aviso de Privacidade antes do envio de
						qualquer dado e só prossegue mediante consentimento expresso.{' '}
						<span className="bold">Titulares afetados:</span> candidatos a vagas de emprego.{' '}
						<span className="bold">Hipótese legal:</span> execução de procedimentos preliminares ao contrato
						(art. 7º, V da LGPD) e consentimento do titular (art. 7º, I da LGPD).{' '}
						<span className="bold">Dados utilizados:</span> nome, telefone, e-mail, RG ou CNH, endereço,
						histórico profissional e demais dados enviados voluntariamente pelo candidato.
					</p>

					<p className="subtitle bold blue">Cumprimento de obrigações legais</p>
					<p>
						<span className="bold">Finalidade:</span> atender exigências do Código de Defesa do Consumidor,
						legislação tributária e trabalhista. <span className="bold">Titulares afetados:</span> clientes,
						passageiros, remetentes de carga e colaboradores. <span className="bold">Hipótese legal:</span>{' '}
						obrigação legal (art. 7º, II da LGPD). <span className="bold">Dados utilizados:</span> conforme
						exigência legal aplicável.
					</p>

					<h2 className="blue bold">4. Com quem compartilhamos seus dados?</h2>
					<p>
						Compartilhamos seus dados somente quando necessário e sempre com base em finalidade legítima. Por
						exemplo:
					</p>
					<ul>
						<li>
							A empresa processadora de pagamentos recebe os dados necessários para aprovar a transação;
						</li>
						<li>
							No processo seletivo: o setor de Recursos Humanos (DHO), os gestores da vaga e eventuais terceiros contratados
							para recrutamento têm acesso aos dados dos candidatos, bem como as ferramentas corporativas de
							armazenamento (Microsoft SharePoint, OneDrive);
						</li>
						<li>Órgãos públicos podem receber dados quando exigido por lei ou por ordem judicial.</li>
					</ul>
					<p>
						Não vendemos seus dados pessoais. Exigimos contratualmente que todos os nossos parceiros tratem
						suas informações com segurança e confidencialidade, em conformidade com a LGPD.
					</p>

					<h2 className="blue bold">5. Por quanto tempo guardamos seus dados?</h2>
					<p>
						Seus dados são armazenados pelo tempo necessário ao cumprimento das finalidades para as quais
						foram coletados, observados os seguintes prazos:
					</p>
					<ul>
						<li>Dados de passagens e transações: 5 anos (Código de Defesa do Consumidor);</li>
						<li>Dados fiscais e contábeis: conforme legislação tributária vigente;</li>
						<li>
							Dados de candidatos: pelo período do processo seletivo e por até 12 meses para futuras
							oportunidades, sendo eliminados de forma segura após esse prazo;
						</li>
						<li>Dados de marketing: enquanto a autorização estiver ativa.</li>
					</ul>
					<p>
						Após o cumprimento das finalidades e o fim dos prazos aplicáveis, seus dados são eliminados de
						forma segura ou anonimizados.
					</p>

					<h2 className="blue bold">6. Como protegemos seus dados?</h2>
					<p>
						Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados pessoais contra
						acesso não autorizado, perda, alteração ou divulgação indevida, incluindo:
					</p>
					<ul>
						<li>Criptografia de dados em trânsito e em repouso;</li>
						<li>
							Armazenamento em ambiente corporativo restrito (nuvem corporativa com acesso limitado ao setor
							responsável);
						</li>
						<li>
							Exclusão dos dados do dispositivo móvel utilizado no atendimento após o armazenamento seguro;
						</li>
						<li>Controle de acesso restrito por perfil de usuário;</li>
						<li>Monitoramento contínuo de segurança;</li>
						<li>Treinamento periódico de colaboradores sobre proteção de dados.</li>
					</ul>

					<h2 className="blue bold">7. Usamos cookies?</h2>
					<p>
						Sim. Cookies são pequenos arquivos salvos no seu navegador que nos ajudam a melhorar sua
						experiência. Utilizamos três tipos:
					</p>
					<p>
						<span className="bold">Cookies necessários:</span> para o funcionamento correto do site. Não é
						possível desativá-los sem comprometer a navegação.
					</p>
					<p>
						<span className="bold">Cookies de análise:</span> para entender como as pessoas utilizam nosso
						site e identificar melhorias.
					</p>
					<p>
						<span className="bold">Cookies de marketing:</span> para exibir promoções relevantes ao seu
						perfil. Você pode recusá-los a qualquer momento no menu de privacidade do site.
					</p>

					<h2 className="blue bold">8. Quais são os seus direitos?</h2>
					<p>
						A LGPD garante a você, titular dos dados, o direito de: confirmar a existência de tratamento dos
						seus dados; acessar os dados que guardamos sobre você; corrigir informações incorretas ou
						desatualizadas; solicitar a eliminação dos seus dados quando possível por lei; revogar a
						autorização para recebimento de promoções a qualquer momento; solicitar a portabilidade dos seus
						dados a outro fornecedor de serviço; saber com quais parceiros compartilhamos suas informações;
						solicitar a revisão de decisões tomadas exclusivamente por sistemas automatizados; e registrar
						reclamação diretamente junto à ANPD (Autoridade Nacional de Proteção de Dados:{' '}
						<a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer">www.gov.br/anpd</a>).
					</p>
					<p>
						Para exercer qualquer direito, envie um e-mail para{' '}
						<a href="mailto:encarregadodedados@jmt.com.br">encarregadodedados@jmt.com.br</a> com o assunto
						correspondente ao seu pedido — por exemplo: "Acesso aos meus dados", "Correção de dados",
						"Exclusão de dados" ou "Processo de Recrutamento". Respondemos em até 15 dias corridos.
					</p>

					<h2 className="blue bold">9. O que acontece em caso de incidente de segurança?</h2>
					<p>
						Se algum incidente de segurança afetar seus dados e representar risco real a você, seremos
						transparentes: você será notificado diretamente por e-mail ou outro canal cadastrado assim que
						tivermos confirmação do ocorrido, conforme exigido pelo art. 48 da LGPD. A notificação informará a
						natureza do incidente, os dados afetados e as medidas que adotamos para mitigar os riscos.
					</p>

					<h2 className="blue bold">10. Fale com a nossa Encarregada de Proteção de Dados</h2>
					<p>
						Nossa Encarregada de Proteção de Dados (DPO) está à disposição para dúvidas, pedidos e
						reclamações relacionados ao tratamento dos seus dados pessoais. Este canal atende clientes,
						passageiros, remetentes de carga, ex-colaboradores e candidatos a vagas de emprego.
					</p>
					<p>
						<span className="bold">Encarregada Titular:</span> Gabriela Kopeginski
					</p>
					<p>
						<span className="bold">Encarregada Substituta:</span> Silésia Fan
					</p>
					<p>
						<span className="bold">E-mail:</span>{' '}
						<a href="mailto:encarregadodedados@jmt.com.br">encarregadodedados@jmt.com.br</a>
					</p>
					<p>
						<span className="bold">Prazo de resposta:</span> até 15 dias corridos.
					</p>

					{history.length > 1 && (
						<Button primary onClick={history.goBack}>
							Voltar
						</Button>
					)}
				</StyledPolicy>
			</Container>
		)
	}
}

const connectedPolicyPage = withRouter(connect(null)(PolicyPage))
export { connectedPolicyPage as ModuleRootComponent }
